import request from '@/utils/$x';

export async function queryDepartList() {
  return request.get('/department/allList');
}
export async function queryCategories() {
  return request.get('/ptrainer/class/categories');
}
export async function editScheduleRule(params) {
  return request.post('/schedule/admin/addOrUpdate', params);
}
export async function queryList(params) {
  return request.post('/user/queryList', params);
}

export async function getRuleById(params) {
  return request.post('/schedule/admin/ruleById', params);
}

export async function queryGreetingList(params) {
  return request.post('/v1/litta/greet/listBox', params);
}

export async function queryEffPageList(params) {
  return request.post('/v1/litta/rights/effPageList', params);
}

export async function queryRelationPageList(params) {
  return request.post('/v1/litta/rights/relationPageList', params);
}

export async function rightsBind(params) {
  return request.post('/v1/litta/rights/binding', params);
}

export async function rightsUnbound(params) {
  return request.post('/v1/litta/rights/unbound', params);
}

export async function getUserByPhone(params) {
  return request.post('/v1/litta/rights/getUserByPhone', params);
}
export async function queryTagList(params) {
  return request.post('/tag/list', params);
}
export async function queryClassList(params) {
  return request.post('/ptrainer/class/list', params);
}
export async function queryClassLiveLink(params) {
  return request.post('/ptrainer/class/getLiveLink', params);
}
/// 上课课表-课表详情，上课内容
export async function queryClassDetailContent(params) {
  return request.post('/ptrainer/class/detailContent1', params);
}
/// 出勤记录
export async function getAttendStatus(params) {
  return request.post('/ptrainer/class/getAttendStatus', params);
}
/// 出勤记录列表
export async function getCourseAttendRecord(params) {
  return request.post('/ptrainer/class/getCourseAttendRecord', params);
}

/// 上课课表-预约上课，根据手机号获取用户简单信息
export async function getUserByTelephone(params) {
  return request.post('/ptrainer/class/getUserByTelephone', params);
}

/// 体验课
export async function getCourse(params) {
  return request.post('/ptrainer/class/getCourse', params);
}

/// 正式课
export async function queryOnlineCoachList(params) {
  return request.post('/ptrainer/class/queryOnlineCoachList', params);
}

/// 上课课表-预约上课-获取训练计划履约情况信息
export async function getWeekPerformList(params) {
  return request.post('/appoint/class/getWeekPerformList', params);
}

/// 一周课程信息
export async function getWeeklyCoursesByWeekNo(params) {
  return request.post('/appoint/class/getWeeklyCoursesByWeekNo', params);
}

/// 上课课表-预约上课-提交约课
export async function appointClass(params) {
  return request.post('/appoint/class/addClass', params);
}

/// 上课课表-预约上课-取消约课
// export async function cancelClassRoom(params) {
//   return request.post('/appoint/class/cancelClassRoom', params);
// }

/// 查询课程计划详情
export async function getCoursePlanDetail(params) {
  return request.post('/ptrainer/class/getCoursePlanDetail', params);
}

/// 获取约课-课程模板id和name配置
export async function getCourseTemplateList(params) {
  return request.post('/appoint/class/getCourseTemplateList', params);
}

/// 获取教练列表
export async function queryCoachList(params) {
  return request.post('/appoint/class/queryCoachList', params);
}

/// 修改课表
export async function modifyClass(params) {
  return request.post('/appoint/class/modifyClass', params);
}

/// 房间控制
export async function roomCtl(params) {
  return request.post('/ptrainer/class/roomCtl', params);
}

/**
 *上课事件记录
 * @param {*} params
 * @returns
 */
export async function classEventRecord(params) {
  return request.post('/ptrainer/class/event/records', params);
}

/**
 *用户上课课表 --教练评语
 * @param {*} params
 * @returns
 */
export async function getClassRoom(params) {
  return request.post('/consumer/getClassRoom', params);
}

/**
 *
 * @param {*} params
 * @returns
 */
export async function summarize(params) {
  return request.post('/consumer/summarize', params);
}

/**
 *点评详情--根据roomId查询
 * @param {*} params
 * @returns
 */
export async function remarkDetailByRoomId(params) {
  return request.post('/ptrainer/class/homework/remarkDetailByRoomId', params);
}

/// 跳课
export async function skip(params) {
  return request.post('/appoint/class/skip', params);
}

/// 直播列表
export async function listRoomLive(params) {
  return request.post('/ptrainer/class/listRoomLive', params);
}

/// 取消课程原因列表
export async function listReason(params) {
  return request.post('/appoint/class/listReason', params);
}

/// 取消课程原因列表
export async function cancelClass(params) {
  return request.post('/appoint/class/cancel', params);
}

/// 查看取消信息
export async function getCancelInfo(params) {
  return request.post('/appoint/class/getCancelInfo', params);
}

/// 帕加马后台-上课课表-取消前提醒
export async function cancelWarn(params) {
  return request.post('/appoint/class/cancelWarn', params);
}

/// 屏蔽
export async function shield(params) {
  return request.post('/ptrainer/class/playback/shield', params);
}

/// 解封
export async function unblock(params) {
  return request.post('/ptrainer/class/playback/unblock', params);
}

// 分配管理首页
export async function distributionManagerPageList(params) {
  return request.post('/consumer/service/distributionManagerPageList', params);
}

// 删除分配的员工
export async function deleteStaff(params) {
  return request.post('/consumer/service/deleteStaff', params);
}

// 分配管理-&gt;分配列表
export async function distributionList(params) {
  return request.post('/consumer/service/distributionList', params);
}

// 设置员工
export async function settingStaff(params) {
  return request.post('/consumer/service/settingStaff', params);
}

// 获取公众号已创建的标签
export async function getTags(params) {
  return request.post('/schedule/admin/getTags', params);
}

// 创建的标签
export async function createTag(params) {
  return request.post('/schedule/admin/createTag', params);
}

// 编辑标签
export async function updateTag(params) {
  return request.post('/schedule/admin/updateTag', params);
}

// 编辑标签
export async function deleteTag(params) {
  return request.post('/schedule/admin/deleteTag', params);
}

// 公众号标签分页查询
export async function tagPageList(params) {
  return request.post('/schedule/admin/tagPageList', params);
}

// 教练群调度规则配置教练分页查询
export async function scheduleRuleCoach(params) {
  return request.post('/schedule/admin/scheduleRuleCoach', params);
}

// 拉群规则列表
export async function getPullGroupRuleList(params) {
  return request.post('/schedule/admin/pullGroupRuleList', params);
}

/// 完课
export async function getCompleteClassInfoForPalmer(params) {
  return request.post('/ptrainer/class/getCompleteClassInfoForPalmer', params);
}
/// 完课点评
export async function getCompleteActionDetailGptResponse(params) {
  return request.post(
    '/ptrainer/class/getCompleteActionDetailGptResponse',
    params,
  );
}

/// 动作骨骼点还原
export async function classActionKeypointsReview(params) {
  return request.post('/ptrainer/class/classActionKeypoints/review', params);
}

/// 课程动作可信结果汇总
export async function classActionKeypointsReliabilitySummary(params) {
  return request.post(
    '/ptrainer/class/classActionKeypoints/reliabilitySummary',
    params,
  );
}

/// 获取课程 V3 分析结果
export async function v3AnalysisDetail(params) {
  return request.post('/ptrainer/class/v3analysis/detail', params);
}

// 群搜索接口
export async function queryGroupChatSimple(params) {
  return request.post('/wxGroupChat/queryGroupChatSimple', params);
}
// 公域商品同步
export async function queryThirdSyncList(params) {
  return request.post('/littaThirdGoods/queryThirdSyncList', params);
}
// 公域商品单商品同步
export async function syncThirdGoodsStatusById(params) {
  return request.post('/littaThirdGoods/syncThirdGoodsStatusById', params);
}
// 保证金统计数据
export async function queryMarginData(params) {
  return request.post('/margin/account/statistics', params);
}
// 保证金统计数据
export async function queryMarginPageList(params) {
  return request.post('/margin/account/pageList', params);
}
// 风控
export async function listRiskDetail(params) {
  return request.post('/risk/listRiskDetail', params);
}
// 风控
export async function releaseRisk(params) {
  return request.post('/risk/releaseRisk', params);
}

// 获取企业客服账号列表
export async function getEnterpriseKfAccountList(params) {
  return request.post('/user/getEnterpriseKfAccountList', params);
}
